import { c as _c } from "react/compiler-runtime";
import React from "react";
import { WaveWinnersDrop } from "./WaveWinnersDrop";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { publicEnv } from "@/config/env";
import { getRenderableWaveDecisionWinners } from "@/helpers/waves/wave-decision.helpers";
interface WaveWinnersDropsProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winners: ApiWaveDecisionWinner[];
  readonly isLoading?: boolean | undefined;
}
export const WaveWinnersDrops: React.FC<WaveWinnersDropsProps> = t0 => {
  const $ = _c(22);
  const {
    wave,
    onDropClick,
    winners,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== isLoading || $[1] !== onDropClick || $[2] !== wave || $[3] !== winners) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const renderableWinners = getRenderableWaveDecisionWinners(winners);
      const invalidWinnerCount = winners.length - renderableWinners.length;
      const shouldShowInvalidWinnerWarning = invalidWinnerCount > 0 && publicEnv.NODE_ENV !== "production";
      const invalidWinnersMessage = invalidWinnerCount === 1 ? "Hidden 1 winner with missing drop data." : `Hidden ${invalidWinnerCount} winners with missing drop data.`;
      if (isLoading) {
        let t6;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
          $[8] = t6;
        } else {
          t6 = $[8];
        }
        t5 = t6;
        break bb0;
      }
      if (!renderableWinners.length) {
        if (shouldShowInvalidWinnerWarning) {
          let t6;
          if ($[9] !== invalidWinnersMessage) {
            t6 = <p className="tw-rounded-md tw-border tw-border-amber-500/40 tw-bg-amber-500/10 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-200">{invalidWinnersMessage}</p>;
            $[9] = invalidWinnersMessage;
            $[10] = t6;
          } else {
            t6 = $[10];
          }
          t5 = t6;
          break bb0;
        }
        let t6;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <></>;
          $[11] = t6;
        } else {
          t6 = $[11];
        }
        t5 = t6;
        break bb0;
      }
      t2 = "tw-space-y-3";
      if ($[12] !== invalidWinnersMessage || $[13] !== shouldShowInvalidWinnerWarning) {
        t3 = shouldShowInvalidWinnerWarning ? <p className="tw-rounded-md tw-border tw-border-amber-500/40 tw-bg-amber-500/10 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-200">{invalidWinnersMessage}</p> : null;
        $[12] = invalidWinnersMessage;
        $[13] = shouldShowInvalidWinnerWarning;
        $[14] = t3;
      } else {
        t3 = $[14];
      }
      let t6;
      if ($[15] !== onDropClick || $[16] !== wave) {
        t6 = winner => <WaveWinnersDrop key={winner.drop.id} winner={winner} wave={wave} onDropClick={onDropClick} />;
        $[15] = onDropClick;
        $[16] = wave;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      t4 = renderableWinners.map(t6);
    }
    $[0] = isLoading;
    $[1] = onDropClick;
    $[2] = wave;
    $[3] = winners;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4) {
    t6 = <div className={t2}>{t3}{t4}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};